const routes = [
    {
        path: "/library/reservations/admin",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isAdmin:true,
            isStaff:true,
            permissions:"libraryreservation_index",
        }
    }
];

export default routes;
